export default {
  namespaced: true,
  state: {
    items: [],
    values: null,
    options: []
  },
  getters: {},
  actions: {
    async GetEvents ({ rootState, dispatch }, { page, limit, getAll }) {
      return await dispatch('fetchDataWithParams', { stream: 'api/events/getEvents', params: { userID: rootState.auth.authId, page, limit, getAll } }, { root: true })
    },
    async HideEvent ({ rootState, dispatch }, id) {
      return await dispatch('putData', { stream: `api/events/${id}/hide` }, { root: true })
    }
  }
}
